<template>
  <div class="dialog-op-user-editor-wrapper">
    <el-dialog title="添加运维用户" :visible="visible" @open="onDialogOpen" @close="onDialogClose">
      <el-form label-position="top" ref="form" :rules="formRule" :model="form">

        <el-form-item label="用户名称" prop="username">
          <el-input v-model="form.username"></el-input>
        </el-form-item>

        <el-form-item label="登录密码" prop="password">
          <el-input type="password" v-model="form.password"></el-input>
        </el-form-item>

        <el-form-item label="确认登录密码" prop="confirmPwd">
          <el-input type="password" v-model="form.confirmPwd"></el-input>
        </el-form-item>

        <el-form-item label="是否为管理员" prop="isAdmin">
          <el-radio v-model="form.isAdmin" :label="1">是</el-radio>
          <el-radio v-model="form.isAdmin" :label="0">否</el-radio>
        </el-form-item>

        <el-form-item label="角色" prop="roleId" v-if="form.isAdmin === 0">
          <el-select v-model="form.roleId">
            <el-option
              v-for="role in roleList"
              :key="role.role_id"
              :label="role.name"
              :value="role.role_id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="代理商" prop="agentIdList">
          <el-select
            multiple
            collapse-tags
            v-model="form.agentIdList">
            <el-option
              v-for="agent in agentList"
              :key="agent.agentid"
              :label="agent.agentname"
              :value="agent.agentid">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="备注" prop="alias" v-if="mode === 'create'">
          <el-input v-model="form.alias"></el-input>
        </el-form-item>

        <el-form-item style="display: flex; justify-content: center;">
          <el-button type="danger" @click="onSubmit">确定</el-button>
          <el-button @click="onCancel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'DialogOpUserEditor',
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    mode: {
      type: String,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    roleList: {
      type: Array,
      required: true
    },
    agentList: {
      type: Array,
      required: true
    }
  },
  data () {
    const confirmPassRule = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    return {
      form: {
        username: '',
        alias: '',
        password: '',
        confirmPwd: '',
        roleId: 0,
        isAdmin: 0,
        agentIdList: []
      },
      formRule: {
        username: [
          { required: true, message: '请输入用户的名称', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' }
        ],
        confirmPwd: [
          { required: true, message: '请输入确认登录密码', trigger: 'blur' },
          { validator: confirmPassRule, trigger: 'blur' }
        ],
        roleId: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    onDialogOpen () {
      if (this.mode === 'update') {
        const agentIdList = []
        for (const agent of this.user.agent_list) {
          agentIdList.push(agent.agent_id)
        }
        console.log(agentIdList)
        this.form = {
          username: this.user.username,
          alias: this.user.alias,
          password: '',
          confirmPwd: '',
          roleId: this.user.role.role_id || 0,
          isAdmin: this.user.is_admin,
          agentIdList: agentIdList
        }
      } else {
        this.form = {
          username: '',
          alias: '',
          password: '',
          confirmPwd: '',
          roleId: 0,
          isAdmin: 0,
          agentIdList: []
        }
      }
    },
    onDialogClose () {
      this.$emit('change', false)
    },

    async onSubmit () {
      try {
        await this.$refs['form'].validate

        this.$emit('change', false)
        this.$emit('submit', this.form)
      } catch (err) {
        console.log(err)
      }
    },
    onCancel () {
      this.$emit('change', false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/sass/base";
</style>



// WEBPACK FOOTER //
// src/pages/op/acl/components/DialogOpUserEditor.vue